import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.config.productionTip = false
Vue.use(VueSweetalert2);

require('./common/inputValidationRules');
require('./common/prototypeMethods');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
